<mat-card>
  <mat-card-content>
    <mat-card-title>{{data.title}}</mat-card-title>
    <mat-card-subtitle>
      {{data.subtitle}}
    </mat-card-subtitle>
    <form [formGroup]="dynamicForm" *ngIf="dynamicForm">

      <div fxLayout="row wrap">
        <div class="p-10" fxFlex.gt-sm="50" fxFlex.gt-xs="50" fxFlex="100" *ngFor="let item of keys">
          <mat-form-field>
            <input matInput placeholder={{item}} [formControl]="dynamicForm.controls[item]" >
          </mat-form-field>
          <mat-hint *ngIf="dynamicForm.controls[item].hasError('required') && dynamicForm.controls[item].touched" class="text-danger font-14">Requerido</mat-hint>

        </div>


      </div>

      <mat-card-actions>
        <button mat-raised-button color="primary" [disabled]="!dynamicForm.valid" (click)="onClickSubmit()">Guardar</button>
        <button mat-raised-button color="danger" (click)="borrar()"  *ngIf=" data.dataForm[data.id]">Eliminar</button>
      </mat-card-actions>
    </form>
  </mat-card-content>
</mat-card>
